import * as Yup from "yup";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import moment from 'moment';
import '../css/notifications.css';
import { useEffect, useState } from "react";
import { deleteNotificationsById, getNotificationsById, upsertNotifications } from "../Path/Path";
import swal from "sweetalert";

// datetime-local <input> expects "YYYY-MM-DDTHH:mm" in LOCAL time.
const toLocalInput = (d) => (d ? moment(d).format("YYYY-MM-DDTHH:mm") : "");
const defaultWhen = () => moment().add(1, "hour").startOf("minute").format("YYYY-MM-DDTHH:mm");

function DynamicNotificationsForm(props) {

    const { onCancel, data } = props;

    const [notifications, setNotifications] = useState({ notifications: [], });

    const handleSubmit = async (values) => {
        var elements = values.notifications.map(i => {
            return {
                message: i.message,
                // Local datetime-local string → ISO (UTC) for the backend.
                scheduledAt: i.scheduledAt ? new Date(i.scheduledAt).toISOString() : null,
                appId: data.appId,
            }
        });
        var payload = { elements };
        if(values.notifications.length > 0) {
            const postData = await upsertNotifications(payload);
            console.log(postData);
            if(postData.acknowledged || postData.success) {
                swal("Updated!", "Notifications Updated successful ", "success");
                onCancel();
            } else {
                swal({
                    title: "Error!",
                    text: "Notifications Update Error",
                    icon: "error",
                    dangerMode: true,
                });
            }
        } else {
            const DeleteNotifications = await deleteNotificationsById(data.appId);
            console.log(DeleteNotifications);
            if(DeleteNotifications.success) {
                swal("Updated!", "Notifications Updated successful ", "success");
                onCancel();
            } else {
                swal({
                    title: "Error!",
                    text: "Notifications Update Error",
                    icon: "error",
                    dangerMode: true,
                });
            }
        }
    };

    useEffect(() => {
        if(!data.appId){
            onCancel();
        } else {
            loadNotifications(data.appId);
        }
    }, [data]);

    const loadNotifications = async (appId) => {
        var dataNotifications = await getNotificationsById(appId);
        // Only show UPCOMING (not-yet-sent) entries in the editable schedule.
        // Already-sent ones live in the History tab.
        dataNotifications = (dataNotifications || [])
            .filter(i => !i.sent)
            .map(i => {
                return {
                    message: i.message,
                    scheduledAt: toLocalInput(i.scheduledAt),
                    appId: i.appId,
                }
            })
        setNotifications({ notifications: dataNotifications, });
    }

    return (
        <div className="container m-3">
        <Formik
            initialValues={notifications}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
                notifications: Yup.array()
                  .of(
                    Yup.object().shape({
                      message: Yup.string().required("Message required"),
                      scheduledAt: Yup.string().required("Date & time required"),
                    })
                  )
              })
            }
            render={({ values, errors }) => {
                return (
                    <Form>
                        <FieldArray
                            name="notifications"
                            render={(arrayHelpers) => (
                                <div className="">
                                    {
                                        values.notifications.length < 6 && (
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() =>
                                                    arrayHelpers.insert(values.notifications.length, {
                                                        message: "",
                                                        scheduledAt: defaultWhen(),
                                                    })
                                                }
                                                style={{ fontSize: "12px", marginBottom: '10px' }}
                                            >
                                                Add Notification
                                            </button>
                                        )
                                    }
                                    {values.notifications.map((time, index) => (
                                        <div className="row" style={{ alignItems: "center", }} key={index}>
                                            <div className="col-6">
                                                <div className="mb-3" style={{ position: "relative", }}>
                                                    <label htmlFor="" className="form-label">
                                                        Message
                                                    </label>
                                                    <Field
                                                        className="form-control"
                                                        name={`notifications.${index}.message`}
                                                        placeholder="Notification Message"
                                                    />
                                                    <div className="form-text text-danger" style={{ position: "absolute", bottom: '-20px', left: "0px", }}>
                                                        <ErrorMessage name={`notifications.${index}.message`} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <div className="mb-3" style={{ position: "relative", }}>
                                                    <label htmlFor="" className="form-label">
                                                        Date &amp; Time
                                                    </label>
                                                    <Field
                                                        className="form-control"
                                                        type="datetime-local"
                                                        name={`notifications.${index}.scheduledAt`}
                                                    />
                                                    <div className="form-text text-danger" style={{ position: "absolute", bottom: '-20px', left: "0px", }}>
                                                        <ErrorMessage name={`notifications.${index}.scheduledAt`} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-1">
                                                <button
                                                    className="btn btn-sm btn-danger m-2"
                                                    type="button"
                                                    onClick={() => arrayHelpers.remove(index)}
                                                >
                                                    -
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                    <div className='but-flex'>
                                        <div className='cancel'>
                                            <div onClick={() => { onCancel() }}>
                                                {"Cancel"}
                                            </div>
                                        </div>
                                        <div className='save-changes'>
                                            <button className="btn btn btn-primary" type="submit">
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                    </Form>
                )
            }}
        />
        </div>
    );
}

export default DynamicNotificationsForm;
